import { IAction } from '~/src/store';

import { EPaymentActions } from './index';

export type TToggleCreditSelection = IAction<EPaymentActions.TOGGLE_CREDIT_SELECTION, string>;

const toggleCreditSelection = (applicationId: string) => ({
    type: EPaymentActions.TOGGLE_CREDIT_SELECTION,
    payload: applicationId,
});

export default toggleCreditSelection;
